const services = [
  { icon: "ri-building-2-line", title: "Real Estate Development", description: "Full-scale residential development with meticulous planning, quality execution, and delivery focused on long-term value for homebuyers and investors in Bengaluru." },
  { icon: "ri-home-heart-line", title: "Villa Design", description: "Tailor-made villa design from concept to materials — crafted for modern families seeking premium living with thoughtful architecture and refined finishes." },
  { icon: "ri-layout-grid-line", title: "Layout Development", description: "Well-planned residential layouts with clear structure, usability, and future property value in mind — designed for communities that grow with time." },
  { icon: "ri-home-smile-line", title: "Affordable Villas", description: "Thoughtfully designed villas that balance quality, comfort, and value — making premium living accessible without compromising on standards." },
  { icon: "ri-map-pin-2-line", title: "Premium Residential Plots", description: "Residential plots in well-connected Bengaluru locations with strong investment potential and complete documentation." },
  { icon: "ri-customer-service-2-line", title: "Property Consultation", description: "Expert guidance for buyers who want help choosing the right property or project — from budget planning to location analysis and legal clarity." },
  { icon: "ri-calendar-check-line", title: "Site Visit Assistance", description: "Dedicated support for booking and arranging visits to our projects — making the process smooth, informative, and easy for serious buyers." },
];

export default function ServicesGrid() {
  return (
    <section className="py-16 md:py-20 bg-[#EAF5E1]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white border border-[#7FBF3F]/20 text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            <i className="ri-apps-line"></i>All Services
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Everything You Need Under One Roof
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            From plot selection to home delivery, our services cover every stage of your real estate journey in Bengaluru.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div key={service.title} className="group bg-white rounded-xl p-6 border border-[#7FBF3F]/10 hover:border-[#7FBF3F]/30 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center bg-[#EAF5E1] rounded-lg mb-4 group-hover:bg-[#1B2A4A] transition-colors duration-300">
                <i className={`${service.icon} text-xl text-[#7FBF3F] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#212121] mb-2 leading-snug" style={{ fontFamily: "'Playfair Display', serif" }}>{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
